module.exports = __webpack_public_path__ + "static/media/arizona-outline-logo.c231d047.png";